module.exports = __webpack_public_path__ + "img/qfecard-logo-white.498fefdf.svg";